import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

/**
 * Header Component
 * Provides the main navigation and branding for the scottishpower business application
 * Includes responsive mobile menu functionality
 */
@Component({
  selector: 'app-header',
  imports: [CommonModule],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss'
})
export class HeaderComponent {
  isMobileMenuOpen = false;
  isMobileEnergyDropdownOpen = false;
  isMobileGreenSolutionsDropdownOpen = false;
  isMobileHelpDropdownOpen = false;
  isMobileAboutUsDropdownOpen = false;

  /**
   * Toggles the mobile navigation menu open/closed state
   * Used for responsive design on smaller screens
   */
  toggleMobileMenu() {
    this.isMobileMenuOpen = !this.isMobileMenuOpen;
    // Close dropdowns when main menu closes
    if (!this.isMobileMenuOpen) {
      this.isMobileEnergyDropdownOpen = false;
      this.isMobileGreenSolutionsDropdownOpen = false;
      this.isMobileHelpDropdownOpen = false;
      this.isMobileAboutUsDropdownOpen = false;
    }
  }

  /**
   * Toggles the mobile energy dropdown
   */
  toggleMobileEnergyDropdown() {
    this.isMobileEnergyDropdownOpen = !this.isMobileEnergyDropdownOpen;
    // Close other dropdowns
    this.isMobileGreenSolutionsDropdownOpen = false;
    this.isMobileHelpDropdownOpen = false;
    this.isMobileAboutUsDropdownOpen = false;
  }

  /**
   * Toggles the mobile green solutions dropdown
   */
  toggleMobileGreenSolutionsDropdown() {
    this.isMobileGreenSolutionsDropdownOpen = !this.isMobileGreenSolutionsDropdownOpen;
    // Close other dropdowns
    this.isMobileEnergyDropdownOpen = false;
    this.isMobileHelpDropdownOpen = false;
    this.isMobileAboutUsDropdownOpen = false;
  }

  /**
   * Toggles the mobile help dropdown
   */
  toggleMobileHelpDropdown() {
    this.isMobileHelpDropdownOpen = !this.isMobileHelpDropdownOpen;
    // Close other dropdowns
    this.isMobileEnergyDropdownOpen = false;
    this.isMobileGreenSolutionsDropdownOpen = false;
    this.isMobileAboutUsDropdownOpen = false;
  }

  /**
   * Toggles the mobile about us dropdown
   */
  toggleMobileAboutUsDropdown() {
    this.isMobileAboutUsDropdownOpen = !this.isMobileAboutUsDropdownOpen;
    // Close other dropdowns
    this.isMobileEnergyDropdownOpen = false;
    this.isMobileGreenSolutionsDropdownOpen = false;
    this.isMobileHelpDropdownOpen = false;
  }

  /**
   * Closes the mobile navigation menu
   * Typically called when user clicks outside menu or on a menu item
   */
  closeMobileMenu() {
    this.isMobileMenuOpen = false;
    this.isMobileEnergyDropdownOpen = false;
    this.isMobileGreenSolutionsDropdownOpen = false;
    this.isMobileHelpDropdownOpen = false;
    this.isMobileAboutUsDropdownOpen = false;
  }
}
